import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination } from "swiper/modules";
import { Link } from "react-router-dom"
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import '../../../assets/css/bootstrap.css';
import '../../../assets/css/style.css';
// import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { LoginContext } from "../../../context/LoginContext";
import { TfiReload } from "react-icons/tfi";
import NoDataImage from "../../../background.gif";



const MyProfilePage = () => {
  const { isLoggedIn, userId, userName, userData, isPremium } = useContext(LoginContext);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get('name');
  const userid = queryParams.get('id');
  const [load, setLoad] = useState({ start: 0, end: 8 });



  useEffect(() => {


    if (!isLoggedIn) {
      navigate("/login");
    }



    if (name || userid) {

      console.log("name - " + name + " - " + userid);
      const payload = new FormData();
      payload.append("id", userId);
      payload.append("looking", userData.looking_for);
      payload.append("gender", userData.gender);
      payload.append("status", userData.status);
      payload.append("email", userData.email);
      if (name) {
        payload.append("type", "multiple");
        payload.append("name", name);
      }
      if (userid) {
        payload.append("type", "single");
        payload.append("userid", userid);
      }
      axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/search`, payload)
        .then(response => {
          if (response.data.response == "success") {
            setUsers(response.data.users);
            console.log(response.data);
          } else {
            setUsers([]);
            console.log(response.data);
          }

        })
        .catch(error => {
          console.error("There was an error fetching users!", error);
        });
    } else {
      navigate(-1);
    }
  }, [name, userid]);

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const formatHeight = (height) => {
    if (!height) return 'N/A';
    const parts = height.split('.');
    return parts.length === 2 ? `${parts[0]}'${parts[1]}"` : height;
  };

  const handleLoadMore = (data, setdata, api) => {
    setdata({ start: 0, end: (data.end + 8) });
    if ((data.end) > (api.length - 1)) {
      setdata({ start: 0, end: (api.length) });
    }
  };


  return (
    <div className="container search-profile py-5">

      {(users.length < 1 && name) && (
       <div className='position-relative nodataBox' style={{ backgroundImage: `url(${NoDataImage})` }}><div><h2 className={'text-white fw-bold text-center'}>No Match Found With Name : {name}</h2>
          </div>
        </div>
      )}
      {(users.length < 1 && userid) && (<div className='position-relative nodataBox' style={{ backgroundImage: `url(${NoDataImage})` }}><div><h2 className={'text-white fw-bold text-center'}>No Match Found With User Id: {userid}</h2></div></div>)}

      {users.slice(load.start, load.end).map((user, idx) => (
        <Link  to={isPremium?`/view-profile/${user.user_id}`:`/upgrade/${userId}`} className="card mb-3 p-3" key={idx}>
          <div className="row g-4">
            <div className="col-md-4 text-center">
              <img src={process.env.REACT_APP_API_BASE_URL + user.image1} className="img-fluid rounded" alt="Profile" />

              {/*<div className="d-flex justify-content-center mt-2 gap-2">*/}
              {/*  /!*<span className="badge bg-warning text-dark">100+ Viewers</span>*!/*/}
              {/*</div>*/}
            </div>

            <div className="col-md-8">
              <h3 className="mt-3 text-danger"  >{user.name}</h3>
              <h5 className={'text-danger'}>About</h5>
              <p>{user.desc || "This is a sample about section text with placeholder content."}</p>

              <h5 className="mt-4 text-danger">Profile Information</h5>
              <div className="row">
                <div className="col-sm-6">
                  <p><strong>Name:</strong> {user.name} <span style={{ color: "#E53D5C" }}> (HS{user.user_id})</span></p>
                  <p><strong>Age:</strong> {calculateAge(user.dob)} Years</p>
                </div>
                <div className="col-sm-6">
                  <p><strong>Height:</strong> {formatHeight(user.height)} Ft</p>
                  <p><strong>Caste:</strong> {user.caste}</p>
                </div>
              </div>
              {(user.hobbies &&

                <>
                  <h5 className="mt-4 text-danger">Hobbies</h5>
                  <div className="d-flex flex-wrap gap-2">
                    {(user.hobbies ? user.hobbies.split(',') : []).map((hobby, i) => (
                      <span className="badge bg-light text-dark border" key={i}>{hobby}</span>
                    ))}
                  </div></>
              )}


            </div>
          </div>
        </Link>
      ))}


      {(users.length > 8 && load.end != users.length) && <p className="text-center">
        <button onClick={() => handleLoadMore(load, setLoad, users)} className="btn btn-outline-danger"> <TfiReload /> Load More Profiles</button>
      </p>}
    </div>
  );
};

export default MyProfilePage;
